import React from "react";
import { Box, Button, Typography } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowsRotate, faHouseChimney } from "@fortawesome/free-solid-svg-icons";

export default class PageErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, message: "" };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, message: error?.message || "Bilinmeyen hata" };
  }

  componentDidCatch(error, info) {
    console.error("[PageErrorBoundary]", error, info);
  }

  handleRetry = () => {
    this.setState({ hasError: false, message: "" });
  };

  render() {
    if (this.state.hasError) {
      const fullPage = this.props.fullPage;
      const boxSx = fullPage
        ? {
            minHeight: "calc(100vh - 120px)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            p: 3,
          }
        : {
            my: 2,
            p: 2.5,
            borderRadius: 2,
            border: "1px solid",
            borderColor: "error.main",
            background: "rgba(239,68,68,0.06)",
          };

      return (
        <Box sx={boxSx}>
          <Box sx={{ maxWidth: fullPage ? 480 : "100%", textAlign: fullPage ? "center" : "left" }}>
            <Typography variant="subtitle1" fontWeight={700} color="error.main" gutterBottom>
              {this.props.title || "Bu bölüm yüklenemedi"}
            </Typography>
            <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
              {this.state.message}
            </Typography>
            <Box sx={{ display: "flex", gap: 1, justifyContent: fullPage ? "center" : "flex-start", flexWrap: "wrap" }}>
              <Button
                size="small"
                variant="outlined"
                startIcon={<FontAwesomeIcon icon={faArrowsRotate} />}
                onClick={this.handleRetry}
                sx={{ textTransform: "none" }}
              >
                Tekrar dene
              </Button>
              {fullPage ? (
                <Button
                  size="small"
                  variant="contained"
                  startIcon={<FontAwesomeIcon icon={faHouseChimney} />}
                  onClick={() => {
                    window.location.href = "/projeler";
                  }}
                  sx={{ textTransform: "none" }}
                >
                  Projeler
                </Button>
              ) : null}
            </Box>
          </Box>
        </Box>
      );
    }
    return this.props.children;
  }
}
